var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16 -16) scale(1.5 1.5) translate(16 16)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M6.883.448 2.5 6.81l3.399.308-.782 4.435L9.5 5.19l-3.399-.308.782-4.435Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroq);
export default __webpack_public_path__ + "static/media/Groq.a6247586c5e627cf0fcdffc2c9e48f76.svg";
export { ForwardRef as ReactComponent };